export const imageLogin = require('./Login/imgLogin.png');
export const overFooter = require('./Footer/overFooter.svg');
export const logoKolobAgent = require('./Footer/logoKolobAgent.png');
export const poweredNuxiba = require('./Footer/poweredNuxiba.svg');

export const agentHeader = require('./Header/agente_icon.svg');
export const arrowHeader = require('./Header/arrow.svg');
export const arrowHistorialND = require('./Header/arrow_HistorialND.svg');
export const logoHeader = require('./Header/kolob.svg');
export const logoHeaderTxt = require('./Header/kolob_texto.svg');
export const macHeader = require('./Header/mac_adress.svg');
export const logOutHeader = require('./Header/cerrar_sesion.svg');
export const clockHeader = require('./Header/relojHeader.svg');
export const agentInbound = require('./Header/agente_inbound_icon.svg');
export const agentOutbound = require('./Header/agente_outbound_icon.svg');
export const agentBoth = require('./Header/agente_outbound_inbound_icon.svg');
export const successChange = require('./Header/cambio_exitoso.svg');
export const iconConfig = require('./Header/config_icon.svg');
export const hiddenPassword = require('./Header/contrasena_oculta.svg');
export const showPassword = require('./Header/contrasena_visible.svg');
export const changePassIcon = require('./Header/password_icon.svg');
export const queueMessages = require('./Header/mensajes_en_cola_icon.svg');
export const tick = require('./Header/palomita_solita.svg');

export const agentInboundInfo = require('./Header/Agente_in_info.svg');
export const agentOutboundInfo = require('./Header/Agente_out_info.svg');
export const agentBothInfo = require('./Header/Agente_out_in_info.svg');

export const facebookHeader = require('./Header/facebook.svg');
export const linkedinHeader = require('./Header/linkedin.svg');
export const mensajesHeader = require('./Header/mensajes.svg');
export const llamadasHeader = require('./Header/llamadas.svg');
export const mailHeader = require('./Header/mail.svg');
export const twitterHeader = require('./Header/twitter.svg');

export const mensajeriaUnificada = require('./WorkBar/mensajeria_unificada_icon.svg');
export const chatAgenteWB = require('./WorkBar/Chat_agente.svg');
export const noDisponibleWB = require('./WorkBar/No_disponible.svg');
export const marcacionManualWB = require('./WorkBar/marcacion_manual.svg');
export const historialNoDisponibleWB = require('./WorkBar/Historial_no_disponibles.svg');
export const historialLlamadasWB = require('./WorkBar/Historial_de_llamadas.svg');

export const alertIconMessage = require('./MessageBar/AlertIcon.svg');
export const attachedFileMessage = require('./MessageBar/ArchivoAdjuntoIcon.svg');
export const deploBarMessage = require('./MessageBar/barraDesplegar.svg');
export const chatIconMessage = require('./MessageBar/chatIcon.svg');
export const mailIconMessage = require('./MessageBar/mailSmallIcon.svg');
export const twitterIconMessage = require('./MessageBar/twitterSmallIcon.svg');
export const userIconMessage = require('./MessageBar/userIconMessageBig.svg');

export const appleNoAvailable = require('./NoAvailable/Manzana.svg');
export const headerNoAvailable = require('./NoAvailable/NoDisponibleHeader.svg');
export const headerHistorialNA = require('./NoAvailable/HistorialNoDisponibleHeader.svg');
export const undefinedNoAvailable = require('./NoAvailable/NoDisponibleSinDefinir.svg');
export const otherNoAvailable = require('./NoAvailable/Otro.svg');
export const bathRoomNoAvailable = require('./NoAvailable/Sanitarios.svg');
export const selectedNoAvailable = require('./NoAvailable/TipoDeNoDisponibleSeleccionado.svg');

export const iconChatSupervisor = require('./SupervisorChat/chat_supervisor.svg');
export const flechaChatSupervisor = require('./SupervisorChat/Flecha.svg');
export const agentChat = require('./SupervisorChat/agente_chat.svg');
export const supervisorSelected = require('./SupervisorChat/chatconsupervisorseleccionado.svg');
export const sendChat = require('./SupervisorChat/Enviar.svg');
export const workGroup = require('./SupervisorChat/Grupodetrabajo.svg');
export const workGroupSelected = require('./SupervisorChat/grupodetrabajoseleccionado.svg');
export const selectedBack = require('./SupervisorChat/regresar_seleccionado.svg');
export const back = require('./SupervisorChat/regresar.svg');
export const supervisorChat = require('./SupervisorChat/supervisorchat.svg');

export const loadingConsulting = require('./loading.gif');

export const EstadoAgenteDispLlamManual = require('./EstadoAgente/EstadoAgenteDipsLLamMan.svg');
export const EstadoAgenteError = require('./EstadoAgente/EstadoAgenteError.svg');
export const EstadoAgenteNoDisponible = require('./EstadoAgente/EstadoAgenteNoDisp.svg');
export const EstadoAgenteNotas = require('./EstadoAgente/EstadoAgenteNotas.svg');
export const EstadoAgenteTransferencia = require('./EstadoAgente/EstadoAgenteTransfer.svg');
export const AgentStateassistedTransfer = require('./EstadoAgente/AgentStateTransfer.svg');

export const validatingTelephony = require('./ValidandoTelefonia/ValidandoTelefonia.gif');
export const validTelephony = require('./ValidandoTelefonia/telefonia_valida.svg');
export const invalidTelephony = require('./ValidandoTelefonia/telefonia_no_valida.svg');

export const btnCerrar = require('./cerrar.svg');
export const btnCloseBlack = require('./cerrarBlack.svg');
export const btnCloseGray = require('./cerraGray.svg');

export const noVolume = require('./Volume/sin_volumen.svg');
export const noMircrophone = require('./Volume/mute_microfono.svg');
export const microphone = require('./Volume/microfono.svg');
export const mediumVolume = require('./Volume/Volumen_medio.svg');
export const heightVolume = require('./Volume/Volumen_alto.svg');

export const all = require('./UnifiedMessaging/all.svg');
export const chat = require('./UnifiedMessaging/chat.svg');
export const facebook = require('./UnifiedMessaging/facebook.svg');
export const linkedin = require('./UnifiedMessaging/Linkedin.svg');
export const twitter = require('./UnifiedMessaging/twitter.svg');
export const mail = require('./UnifiedMessaging/mail.svg');

export const callIcon = require('./CallWindow/call_key_icon.svg');
export const inboundCall = require('./CallWindow/icono_campana_entrada.svg');
export const outBoundCall = require('./CallWindow/icono_campana_salida.svg');
export const phoneIcon = require('./CallWindow/icono_campana_telefono.svg');
export const typeCell = require('./CallWindow/numero_celular.svg');
export const typeHome = require('./CallWindow/numero_de_casa.svg');
export const typeOffice = require('./CallWindow/numero_oficina.svg');
export const typePricipal = require('./CallWindow/numero_principal.svg');
export const typeDetermined = require('./CallWindow/numero_determinado.svg');
export const key = require('./CallWindow/key.svg');


export const reprogramacion1 = require('./CallWindow/gris_numero_oficina.svg');
export const reprogramacion2 = require('./CallWindow/gris_numero_de_casa.svg');
export const reprogramacion3 = require('./CallWindow/gris_numero_principal.svg');
export const reprogramacion4 = require('./CallWindow/gris_numero_celular.svg');
export const reprogramacion5 = require('./CallWindow/gris_numero_determinado.svg');

export const phoneIconChange = require('./CallWindow/cambioLlamada.svg');

export const dateReschedule = require('./RateCall/fecha.svg');
export const timeReschedule = require('./RateCall/hora.svg');

export const search = require('./Others/buscar.svg');
export const pause = require('./Others/hold.svg');

export const agenda = require('./TransferCall/agenda.svg');
export const agentTransfer = require('./TransferCall/persona_transferencia_asistida.svg');
export const conference = require('./TransferCall/conferencia_icon.svg');
export const transferCall = require('./TransferCall/trasferir_llamada.svg');
export const leaveConference = require('./TransferCall/Abandonar_conferencia.svg');

export const playRecord = require('./CallRecord/Play.svg');
export const moveRecord = require('./CallRecord/pista_anterior.svg');
export const entryCallRecord = require('./CallRecord/llamada_entrada.svg');
export const outCallRecord = require('./CallRecord/llamada_salida.svg');
export const resizeManual = require('./CallRecord/agrandar_manualmente_ventana.svg');
export const checked = require('./CallRecord/check_on.svg');
export const agentMark = require('./CallRecord/marca.svg');
export const adminMark = require('./CallRecord/marca_admin.svg');
export const orderColum = require('./CallRecord/ordenar_columna.svg');
export const leftArrow = require('./CallRecord/left-arrow.svg');
export const rightArrow = require('./CallRecord/right-arrow.svg');
export const firstPage = require('./CallRecord/first_page.svg');
export const lastPage = require('./CallRecord/last_page.svg');
export const iconInfo = require('./CallRecord/Icon_info.svg');

export const entryCallRecordSelected = require('./CallRecord/campana_entrada_blanco.svg');
export const outCallRecordSelected = require('./CallRecord/campana_salida_blanco.svg');

export const alert = require('./Others/alerta.svg');

export const send = require('./DTMF/send.svg');
export const digits = require('./DTMF/digitos.svg');

export const mark = require('./MarkCall/marca.svg');
export const clock = require('./MarkCall/reloj.svg');
export const cross = require('./MarkCall/tache.svg');
export const addMark = require('./MarkCall/anadir_marca.svg');
export const infoAd = require('./ManualCall/info_ad.svg');

var frames = {};
for (let i = 1; i <= 32; i++) {
	frames[i] = require('./OldCampIcons/' + ('00' + i).slice(-3) + '.png');
}
export const framesCamp = frames;

export const connectedIntegration = require('./Integrations/conectado_icon.svg');
export const connectingIntegration = require('./Integrations/conectando_icon.svg');
export const disconnectedIntegration = require('./Integrations/desconectado.svg');
export const notFoundIntegration = require('./Integrations/not_found_icon.svg');



// WEBPACK FOOTER //
// ./src/Images/Images.js